<template>
  <b-dropdown
    style="margin-top: 5px; margin-right: 15px; cursor: pointer"
    :triggers="['hover']"
    aria-role="list"
  >
    <template #trigger>
      <div :class="langIcon" />
    </template>
    <b-dropdown-item
      aria-role="listitem"
      :disabled="langIcon === 'svg-icon-th'"
      @click="changeLocale('th')"
    >
      <div class="svg-icon-th" />
      <span class="has-text-black m-l-5"> ไทย</span>
    </b-dropdown-item>
    <b-dropdown-item
      aria-role="listitem"
      :disabled="langIcon === 'svg-icon-la'"
      @click="changeLocale('la')"
    >
      <div class="svg-icon-la" />
      <span class="has-text-black m-l-5"> ລາວ</span>
    </b-dropdown-item>
    <b-dropdown-item
      aria-role="listitem"
      :disabled="langIcon === 'svg-icon-en'"
      @click="changeLocale('en')"
    >
      <div class="svg-icon-en" />
      <span class="has-text-black m-l-5"> Eng</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { getLocale, setCookieI18n, setLocale } from '@/utils/locale'

export default {
  data() {
    return {
      langIcon: null
    }
  },
  mounted() {
    this.setLangIcon()
  },
  methods: {
    setLangIcon() {
      const lang = getLocale()
      if (lang === 'th') {
        this.langIcon = 'svg-icon-th'
      } else if (lang === 'la') {
        this.langIcon = 'svg-icon-la'
      } else if (lang === 'en') {
        this.langIcon = 'svg-icon-en'
      }
    },
    changeLocale(lang) {
      setLocale(lang)
      setCookieI18n(lang.toUpperCase())
      this.setLangIcon()
      this.$i18n.locale = lang
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .dropdown-content {
  width: 40%;
}
@media (max-width: 1024px) {
  ::v-deep .dropdown-content {
    width: 100%;
  }
}

::v-deep .dropdown-trigger {
  padding: 1px 4px;
  border: 0.5px solid $light-primary;
  border-radius: 4px;
}
.svg-icon-th,
.svg-icon-la,
.svg-icon-en {
  width: 1.5em;
  height: 1.5em;
  background-size: cover;
  float: left;
}
.svg-icon-th {
  background-image: url(~@/assets/logo/th-lang.svg);
}
.svg-icon-la {
  background-image: url(~@/assets/logo/la-lang.svg);
}
.svg-icon-en {
  background-image: url(~@/assets/logo/en-lang.svg);
}
</style>
